import type { AdminGame } from '@mcgames/contracts';
import { gamePath, useGameMutation } from './game-hooks.ts';

export function versionPath(gameId: string, versionId: string): string {
  return `${gamePath(gameId)}/versions/${encodeURIComponent(versionId)}`;
}

/** The part of `versionPath` below the game, as `useGameMutation` takes it. */
function versionSubpath(versionId: string, subpath: string): string {
  return `/versions/${encodeURIComponent(versionId)}${subpath}`;
}

/** A mutation on `<version>/<subpath>`; like every game mutation it answers with the updated game. */
export function useVersionMutation<TBody>(
  gameId: string,
  versionId: string,
  method: 'POST' | 'PATCH' | 'DELETE',
  subpath = '',
) {
  return useGameMutation<TBody>(gameId, method, versionSubpath(versionId, subpath));
}

/** The version a mutation added: the one `after` has and `before` does not. */
export function addedVersionId(before: AdminGame, after: AdminGame): string | null {
  const known = new Set(before.versions.map((version) => version.id));
  return after.versions.find((version) => !known.has(version.id))?.id ?? null;
}
